<script>
	import CreditCard from "./CreditCard.svelte";
	import CreditCardRaiz from "./CreditCardRaiz.svelte";
	import CreditCardFidel from "./CreditCardFidel.svelte";
	import CreditCardBoomerang from "./CreditCardBoomerang.svelte";
	import CreditCardSuperRewards from "./CreditCardSuperRewards.svelte";
	import CreditCardGiveShop from "./CreditCardGiveShop.svelte";
	import CreditCardGeneric from "./CreditCardGeneric.svelte";
	import CreditCardFurthr from "./CreditCardFurthr.svelte";
	import CreditCardDgr from "./CreditCardDGR.svelte";
	import CreditCardp4pUs from "./CreditCardp4pUs.svelte";
	import CreditCardNrma from "./CreditCardNRMA.svelte";
	import CreditCardHumanForce from "./CreditCardHumanForce.svelte";
    import CreditCardCents2Bills from "./CreditCardCents2Bills.svelte";
    import InvalidAccess from "./InvalidAccess.svelte";

	//Get Query Parameters for token and region
	const urlParms = new URLSearchParams(window.location.search);
	const token = urlParms.get("token");
	let region = urlParms.get("region");
	let network = urlParms.get("network");
	let app = urlParms.get("client");
	let email = urlParms.get("email");
	let bpayid = urlParms.get("bpid");
	let screen = urlParms.get("screen");

	if (region) {
		region = region.toLowerCase();
	} else {
		region = "au";
	}

	if (app) {
		app = app.toLowerCase();
	}

	console.log(region);
</script>

{#if network !== null && token !== null}
	<CreditCardGeneric {token} {region} {network} />
{:else if token !== null}
	{#if app !== null && app === "raiz"}
		<CreditCardRaiz {token} {region} />
	{:else if app !== null && app === "nrma"}
		<CreditCardNrma {token} />
	{:else if app !== null && app === "isponsor"}
		<CreditCardFidel {token} />
	{:else if app !== null && app === "humanforce"}
		<CreditCardHumanForce {token} />
	{:else if app !== null && app === "cents2bills"}
		<CreditCardCents2Bills {token} />
	{:else if app !== null && app === "giveshop"}
		<CreditCardGiveShop {token} />
	{:else if app !== null && app === "p4pus"}
		<CreditCardp4pUs {token} />
	{:else if app !== null && app === "superrewards"}
		<CreditCardSuperRewards {token} />
	{:else if app !== null && app === "doinggoodrewards"}
		<CreditCardDgr {token} />
	{:else if app !== null && app === "furthr"}
		<CreditCardFurthr {token} {screen} />
	{:else}
		<CreditCard {token} {region} />
	{/if}
{:else if app !== null && app === "loyaltyboomerang" && email !== null && bpayid !== null}
	<CreditCardBoomerang {email} {bpayid} />
{:else}
	<InvalidAccess />
{/if}
